import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IncomingCallComponent } from './incoming-call.component';
import { RouterModule } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { ApiIncomingCallService } from 'app/services/api/api-incoming-call-service';

const routes = [
    {
        path: 'call/incoming/:token',
        component: IncomingCallComponent,
    }
];

@NgModule({
    declarations: [IncomingCallComponent],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        FuseSharedModule,
    ],
    exports: [IncomingCallComponent],
    providers: [ApiIncomingCallService]
})
export class IncomingCallModule { }
